import React from "react";

import {
  t,
  SUGGESTIONS_L1,
  SUGGESTIONS_L2,
  SUGGESTIONS_L3,
  SUGGESTIONS_L4,
  SUGGESTIONS_L5,
  SUGGESTIONS_L6,
  SUGGESTIONS_L7_1,
  SUGGESTIONS_L7_2,
} from "../../translations/AboutUs/SutpIts";

function Suggestions() {
  return (
    <div class="main-container">
      <div class="main-header">{t(SUGGESTIONS_L1)}</div>
      <div class="wrap2">{t(SUGGESTIONS_L2)}</div>
      <div class="wrap6">
        {t(SUGGESTIONS_L3)} <br />
        {t(SUGGESTIONS_L4)} <br />
        {t(SUGGESTIONS_L5)} <br />
        {t(SUGGESTIONS_L6)} <br />
        {t(SUGGESTIONS_L7_1)}
        <a class="href-link" href="md@ksrtc.org" target="_blank">
          {t(SUGGESTIONS_L7_2)}
        </a>
      </div>
    </div>
  );
}

export default Suggestions;
